module.exports = __webpack_public_path__ + "media/images/ringrevenue/button_left_export-53e3e8348379350f9b03511a7d0d2c84.png";